import { LoadMore as LoadMoreBase } from "@gebruederheitz/wp-async-posts-loader";


export class LoadMore extends LoadMoreBase {

    /**
     * Include custom filters.
     */
    getRequestPath(page = 0) {
        let path = super.getRequestPath(page);

        if (this.person) {
            path += `&person=${this.person}&partial=person`;
        }

        return path;
    }

    /**
     * Initialize the custom filters required by reading settings from the
     * button element's data attributes.
     */
    initFilters() {
        this.person = false;

        if (this.button.dataset) {
            this.person = this.button.dataset.ghwpPerson || 0;
        }
    }
}
